<span *ngIf="label">
  <ion-item button [ngStyle]="{'padding-left': (16 * level) + 'px'}" lines="none" (click)="selectLabel()">
    <ion-label class="ion-text-wrap">
      {{label.name}}
    </ion-label>
    <ion-button slot="end" fill="clear" [disabled]="true" color="light">
      <ion-icon [name]="label.is_active ? 'eye-off':'eye'" slot="icon-only"></ion-icon>
    </ion-button>
  </ion-item>

</span>